import React from 'react';
import pt from 'prop-types';
import Flash from 'components/flash';
import LoadingBar from 'components/loading/bar';
import getModal from 'partners/containers/modals';
import { NavMain } from 'partners/components/nav';

import 'components/layout/main.scss';

export default class MainLayout extends React.Component {
  static propTypes = {
    router: pt.object,
    flash: pt.object,
    nav: pt.object,
    modal: pt.object,
    children: pt.node,
  };

  renderActiveModals(modal, props) {
    return modal.stack.map((activeModal, index) =>
      typeof activeModal.props === 'function' ? (
        <activeModal.props key={index} {...props} />
      ) : (
        getModal(activeModal.id, index, { ...props, ...activeModal.props })
      ),
    );
  }

  render() {
    const { nav, flash, children, modal, ...props } = this.props;

    const { routes } = this.props.router;
    const targetRoute = routes[routes.length - 1];
    const showingLayout = targetRoute.layout !== false;
    const showingLoader = targetRoute.loader !== false;

    return (
      <div id="main" className="layout-container">
        <Flash {...flash} />
        {showingLoader && <LoadingBar />}
        {showingLayout ? (
          <div>
            <NavMain nav={nav} {...props} />
            <div className="layout-content partner-dashboard">{children}</div>
          </div>
        ) : (
          children
        )}
        {this.renderActiveModals(modal, props)}
      </div>
    );
  }
}
